import { SKILL_INFO } from './workflowShared';

interface SkillInfoModalProps {
  isOpen: boolean;
  availableSkills: string[];
  onClose: () => void;
}

function ModalCloseButton({ onClose, disabled = false }: { onClose: () => void; disabled?: boolean }) {
  return (
    <button
      className="modal-close"
      type="button"
      onClick={onClose}
      disabled={disabled}
      aria-label="Close modal"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  );
}

function SkillInfoModal({ isOpen, availableSkills, onClose }: SkillInfoModalProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(event) => event.stopPropagation()}>
        <div className="modal-header">
          <h2>About Skills</h2>
          <ModalCloseButton onClose={onClose} />
        </div>

        <div className="modal-body">
          <div className="skill-info-notice">
            <p>
              Note: All skills are taken from their respective repositories without modification.
              These skills are maintained by their original authors and used as provided.
            </p>
          </div>

          <div className="skill-info-list">
            {availableSkills.map((skillKey) => {
              const info = SKILL_INFO[skillKey];

              if (!info) {
                return null;
              }

              return (
                <div key={skillKey} className="skill-info-item">
                  <h3>{info.title}</h3>
                  <p>{info.description}</p>
                  <a
                    href={info.sourceUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="skill-source-link"
                  >
                    View source
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export { ModalCloseButton };
export default SkillInfoModal;
